import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchHtmlPageByName } from "../../services/htmlPageService";

const Links = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [htmlContentLeft, setHtmlContentLeft] = useState("");
  const [htmlContentRight, setHtmlContentRight] = useState("");
  const [htmlContentFooter, setHtmlContentFooter] = useState("");

  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const [main, left, right, footer] = await Promise.all([
          fetchHtmlPageByName("helpfullinks"),
          fetchHtmlPageByName("helpfullinks-Left"),
          fetchHtmlPageByName("helpfullinks-Right"),
          fetchHtmlPageByName("helpfullinks-Footer"),
        ]);

        setHtmlContent(main.data.content);
        setHtmlContentLeft(left.data.content);
        setHtmlContentRight(right.data.content);
        setHtmlContentFooter(footer.data.content);
      } catch (error) {
        console.error("Error fetching HTML page content:", error);
        setError("Failed to load content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) return <div>Loading...</div>; // Display loading indicator
  if (error) return <div>{error}</div>; // Display error message if any

  return (
    <div className="row justify-content-center">
      <div className="col-10">
        <img
          alt=""
          src={require("../../img/masthead3.png")}
          style={{ align: "center" }}
          className="img-fluid"
        />
        <div className="row mt-5 mb-5">
          <strong>
            <h3 className="text-center fw-bold">
              <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </h3>
          </strong>
        </div>
      </div>
      <div className="row justify-content-around">
        <div className="col-10">
          <div className="border border-warning m-2">
            <div className="row m-2">
              <div className="col-lg-6">
                <div dangerouslySetInnerHTML={{ __html: htmlContentLeft }} />
              </div>
              <div className="col-lg-6">
                <div dangerouslySetInnerHTML={{ __html: htmlContentRight }} />
              </div>
            </div>
            <div className="row m-2">
              <div dangerouslySetInnerHTML={{ __html: htmlContentFooter }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Links;
